import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { FaSpinner } from "react-icons/fa";
import config from "../../config";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";
import RichTextEditor from "../RichTextEditor";

const RestaurantCity = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [restaurant, setRestaurant] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [subCategory, setSubCategory] = useState([]);

  const [cities, setCities] = useState([]);
  // const [cities, setCities] = useState([]);

  // const [stateId, setStateId] = useState("");
  // const [cityId, setCityId] = useState("");

  const axiosAPI = useAxios();
  const BASE_URL = config?.apiBaseUrl;

  const [formData, setFormData] = useState({

    city: "",
    meta_title: "",
    meta_description: "",
    heading: "",
    description: "",
    is_active_or_inactive: "",

  });

  function removeFormData() {
    setFormData({
      city: "",
      meta_title: "",
      meta_description: "",
      heading: "",
      description: "",
      is_active_or_inactive: "",
    });
  }

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  async function fetchRestaurant() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/restaurantCities?page=${page}`);
      setRestaurant(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      setRestaurant([]);
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  async function fetchSubCategory(id) {
    try {
      const response = await axiosAPI.get(`/api/v1/all-subcategories`);
      setSubCategory(response?.data?.subcategories);
    } catch (error) {
      console.error("Error fetching category:", error);

      setSubCategory([]);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    const payload = {
      city: formData.city,
      meta_title: formData.meta_title,
      meta_description: formData.meta_description,
      heading: formData.heading,
      description: formData.description,
      is_active_or_inactive: formData.is_active_or_inactive,
    };

    console.log("ratin", payload)
    try {
      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/restaurantCities/${currentUserId}`,
          payload
        );

        window.notifyMessage(
          "Success",
          "Restaurant details updated successfully",
          "success"
        );
      } else {
        response = await axiosAPI.post(`/api/restaurantCities`, payload);

        window.notifyMessage(
          "Success",
          "Restaurant details added successfully",
          "success"
        );
      }

      hideModal("newUserModal");
      removeFormData();
      fetchRestaurant(); // refresh list
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", errorMsg, "danger");
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  // console.log("restaurant", restaurant);
  const openEditModal = (restaurantId) => {
    setIsEditMode(true);
    showModal("newUserModal");
    setCurrentUserId(restaurantId);

    // Use a different variable heading in the callback
    const productToEdit = restaurant.find(
      (restaurant) => restaurant.id === restaurantId
    );


    // setStateId(productToEdit?.state || "");
    // setCityId(productToEdit?.city || "");
    console.log("Id", productToEdit);

    setFormData((prev) => ({
      ...prev,

      city: productToEdit?.city || "",
      meta_title: productToEdit?.meta_title || "",
      meta_description: productToEdit?.meta_description || "",
      heading: productToEdit?.heading || "",
      description: productToEdit?.description || "",
      is_active_or_inactive: productToEdit?.is_active_or_inactive || "",
    }));

    // setStateId( "");
    // setCityId( "");
  };

  console.log("Form", formData)


  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/restaurantCities/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchRestaurant();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  async function changeRestaurantStatus(e, restaurantId) {
    const currentStatus = e.target.value;

    // console.log("product  Id", blogId);
    // console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the product card status?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/restaurantCities/change-restaurant-status/${restaurantId}`,
        { status: currentStatus }
      );

      fetchRestaurant();
      window.notifyMessage(
        "Success",
        "Restaurant status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing product status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change restaurant status. Please try again.",
        "danger"
      );
    }
  }

  function openMediaLibraryModal() {
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }
  function openBlogModal() {
    showModal("newUserModal");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  useEffect(() => {
    fetchSubCategory();
  }, []);

  useEffect(() => {
    fetchRestaurant();
  }, [page]);


  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await axiosAPI.get("/api/restaurantCities/cities");

        if (res.data.success) {
          setCities(res.data.data)
        }
      } catch (err) {
        console.error("Error loading cities:", err);
      }
    };

    fetchCities();
  }, []);


  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openBlogModal()}
            >
              Add Restaurant Cities
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Restaurant" : "Add Restaurant Cities"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>







                  {/* Full meta_title */}
                  <div className="mb-3">
                    <label htmlFor="meta_title" className="form-label">
                      Meta Title
                    </label>
                    <input
                      className="form-control"
                      id="meta_title"
                      placeholder="Enter Meta Title"
                      value={formData.meta_title}
                      onChange={handleChange}
                    ></input>
                  </div>

                  {/* Meta Description */}
                  <div className="mb-3">
                    <label htmlFor="meta_description" className="form-label">
                      Meta Description
                    </label>
                    <textarea
                      className="form-control"
                      id="meta_description"
                      rows="3"
                      placeholder="Enter Meta Description"
                      value={formData.meta_description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {/* Heading */}
                  <div className="mb-3">
                    <label htmlFor="heading" className="form-label">
                      Heading
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="heading"
                      placeholder="Enter Heading"
                      value={formData.heading}
                      onChange={handleChange}
                    />
                  </div>


                  {/* Description */}
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="3"
                      placeholder="Enter Description"
                      value={formData.description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="row">
                    {/* Restaurant city_id */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">City</label>
                      <select
                        className="form-select"
                        value={formData.city}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            city: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select City</option>
                        {cities?.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Active or Inactive */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="is_active_or_inactive" className="form-label">
                        Active or Inactive
                      </label>
                      <select
                        className="form-select"
                        id="is_active_or_inactive"
                        name="is_active_or_inactive"
                        value={formData.is_active_or_inactive}
                        onChange={handleChange}
                      >
                        <option value="NO">No</option>
                        <option value="YES">Yes</option>
                      </select>
                    </div>
                  </div>


                  <button
                    type="submit"
                    className="btn btn-primary  btn-sm"
                    disabled={loading}
                  >
                    {loading ? (
                      <FaSpinner className="spinner" spin />
                    ) : isEditMode ? (
                      "Update Restaurant"
                    ) : (
                      "Add Restaurant Cities"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* restaurant Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  Restaurants Cities ({restaurant?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr no</th>
                        <th>City Id</th>
                        <th>Meta Title</th>
                        <th>Meta Description</th>
                        <th>Active or Inactive</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : restaurant?.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No restaurants found.
                          </td>
                        </tr>
                      ) : (
                        restaurant &&
                        restaurant?.map((restaurant, index) => (
                          <tr key={restaurant.id}>
                            <td>{index + 1}</td>
                            <td>{restaurant?.city_id}</td>
                            <td>{restaurant?.meta_title}</td>
                            <td>{restaurant?.meta_description}</td>
                            {/* <td>{restaurant?.subcategory_id}</td> */}
                            <td>
                              <select
                                className="form-select"
                                value={restaurant.is_active_or_inactive}
                                onChange={(e) =>
                                  changeRestaurantStatus(e, restaurant?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(restaurant.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(restaurant.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantCity;


